import WebGalleryUpsellBannerFWGOnlyContent from './WebGalleryUpsellBannerFWGOnlyContent';

export default WebGalleryUpsellBannerFWGOnlyContent;
